import { render, staticRenderFns } from "./farmMachinery.vue?vue&type=template&id=21054992&scoped=true"
import script from "./farmMachinery.vue?vue&type=script&lang=js"
export * from "./farmMachinery.vue?vue&type=script&lang=js"
import style0 from "./farmMachinery.vue?vue&type=style&index=0&id=21054992&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21054992",
  null
  
)

export default component.exports